import { render, staticRenderFns } from "./MemberFormsAdmin.vue?vue&type=template&id=20887436"
import script from "./MemberFormsAdmin.vue?vue&type=script&lang=js"
export * from "./MemberFormsAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports